import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import { Link } from "react-router-dom"

function Internships({ data, type_user_session }) {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1600 },
            items: 4,
        },
        desktop: {
            breakpoint: { max: 1599, min: 1200 },
            items: 3,
        },
        laptop: {
            breakpoint: { max: 1199, min: 1024 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 1023, min: 768 },
            items: 2,
        },
        smallTablet: {
            breakpoint: { max: 767, min: 640 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 639, min: 0 },
            items: 1,
        },
    }

    const typeWork = (param) => {
        const id_work_modality = param
        const modality = ["", "Presencial", "Remoto", "Híbrido"]
        return modality[id_work_modality]
    }

    const typeInternship = (param) => {
        const id_type_internship = param
        const typeInternship = ["", "Remunerada", "No remunerada"]
        return typeInternship[id_type_internship]
    }

    const getTypeColor = (id) => {
        switch (id) {
            case 1:
                return "bg-green-500" // Remunerada
            case 2:
                return "bg-gray-500" // No remunerada
            default:
                return "bg-gray-500"
        }
    }

    const getModalityColor = (id) => {
        switch (id) {
            case 1:
                return "bg-blue-500" // Presencial
            case 2:
                return "bg-orange-500" // Remoto
            case 3:
                return "bg-purple-500" // Híbrido
            default:
                return "bg-gray-500"
        }
    }

    return (
        <div className="container px-5 py-4 mx-auto">
            <div className="flex flex-col w-full mb-12">
                <h1 className="text-white font-bold text-2xl sm:text-3xl">Pasantías</h1>
            </div>
            <div className="w-full mx-auto">
                <Carousel
                    responsive={responsive}
                    showDots={true}
                    arrows={false}
                    autoPlay={true}
                    infinite={true}
                    autoPlaySpeed={3000}
                    dotListClass="custom-dot-list-style"
                    className="flex flex-wrap w-full mx-auto"
                >
                    {data.map((Internship) => {
                        return (
                            <div key={Internship.id} className="p-2 h-96 w-full">
                                <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-lg h-full relative w-full overflow-hidden">
                                    <div className="p-6 h-full flex flex-col">
                                        <div className="mb-4 text-xl font-bold tracking-tight text-orange-400 break-words leading-tight">
                                            {Internship.job_title}
                                        </div>

                                        <p className="mb-6 font-normal text-slate-300 text-justify break-words text-sm leading-relaxed flex-grow">
                                            {Internship.description.length > 120
                                                ? Internship.description.substring(0, 120) + "..."
                                                : Internship.description}
                                        </p>

                                        <div className="space-y-3 mb-16">
                                            <div className="inline-block bg-slate-600 rounded-md px-3 py-1 text-sm text-slate-200">
                                                Inicio: {Internship.start_date}
                                            </div>

                                            <div className="flex flex-wrap gap-2">
                                                <span
                                                    className={`inline-block ${getTypeColor(Internship.id_type_internship)} rounded-md px-3 py-1 text-sm font-medium text-white`}
                                                >
                                                    {typeInternship(Internship.id_type_internship)}
                                                </span>
                                                <span
                                                    className={`inline-block ${getModalityColor(Internship.id_work_modality)} rounded-md px-3 py-1 text-sm font-medium text-white`}
                                                >
                                                    {typeWork(Internship.id_work_modality)}
                                                </span>
                                            </div>

                                            <div className="inline-block bg-slate-600 rounded-md px-3 py-1 text-sm text-slate-200">
                                                {Internship.schedules}
                                            </div>
                                        </div>
                                    </div>

                                    {type_user_session === 3 && (
                                        <div className="absolute bottom-0 left-0 right-0">
                                            <Link to={`/informacion-pasantia/${Internship.id}`}>
                                                <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-medium py-3 px-4 transition-colors duration-200 flex items-center justify-center gap-2 rounded-b-lg">
                                                    Ver más
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        className="w-4 h-4"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                                                        />
                                                    </svg>
                                                </button>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </Carousel>
            </div>

            <style jsx>{`
                .custom-dot-list-style {
                    display: flex;
                    justify-content: center;
                    margin-top: 20px;
                }
                .custom-dot-list-style li {
                    margin: 0 5px;
                }
                .custom-dot-list-style li button {
                    background-color: #64748b;
                    border: none;
                    border-radius: 50%;
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                }
                .custom-dot-list-style li.react-multi-carousel-dot--active button {
                    background-color: #f97316;
                }
            `}</style>
        </div>
    )
}

export default Internships
